import { Dropdown, FormController, FormLabel, MenuItem, Typography, } from '@one-thd/sui-atomic-components';
import { Image } from '@one-thd/sui-icons';
import React, { useEffect, useState } from 'react';
import { GetTopSpendByItemQuantity, GetTopSpendByItemSpend, } from '../../hooks/business-tools-hooks';
import { useBusinessToolsContext, useCommonContext, } from '../../hooks/useContexts';
import { DateRanges } from '../../utils/DateRanges';
import { getSvocId } from '../../utils/user';
import { SectionHeader } from '../shared/section-header/SectionHeader';
import { BusinessToolsErrorMessage } from './BuisnessToolsErrorMessage';
import '../../styles/business-tools.scss';
import { TopItemSkeleton } from './BusinessToolsSkeletons';
var styleBars = function (widthNumber) {
    if (widthNumber <= 0.2) {
        return widthNumber > 0 ? { width: '0.2%' } : { width: '0%' };
    }
    return { width: "".concat(widthNumber, "%") };
};
var compareAmounts = function (prevItem, newItem) {
    var property = prevItem === 'totalTransactionAmount'
        ? 'totalTransactionAmount'
        : 'totalQuantity';
    if (prevItem[property] >
        newItem[property])
        return -1;
    if (prevItem[property] <
        newItem[property])
        return 1;
    return 0;
};
// function to calculate width for each element
var spendPercentage = function (firstAmount, otherAmount) {
    if (firstAmount && otherAmount) {
        return (otherAmount / firstAmount) * 100;
    }
    return 0;
};
var getItemPercentage = function (data, denominatorAmount) {
    if (data.totalTransactionAmount) {
        return spendPercentage(denominatorAmount.totalTransactionAmount, data === null || data === void 0 ? void 0 : data.totalTransactionAmount);
    }
    return spendPercentage(denominatorAmount.totalQuantity, data === null || data === void 0 ? void 0 : data.totalQuantity);
};
var renderItemImage = function (data) {
    if (data.imageURL) {
        return (React.createElement("img", { width: 75, height: 75, className: "business-tools__imageWidthHeight", src: data.imageURL, alt: "item" }));
    }
    return (React.createElement("div", { style: { padding: 15 } },
        ' ',
        React.createElement(Image, { size: "large" })));
};
// TODO: Not currently being used, check if can be removed
// const getOptionsValues = (
//   data: IItemSpend & IItemQuantity,
//   contextData: IContextData,
// ) => {
//   if (contextData.dateSelectorValue === 'custom') {
//     return {
//       requestSearchSelectorValue: 'SKUNumber',
//       requestSearchCriteria: data.skuNumber,
//       startDate: contextData.startDate,
//       endDate: contextData.endDate,
//       dateSelectorValue: contextData.dateSelectorValue,
//     };
//   }
//   return {
//     requestSearchSelectorValue: 'SKUNumber',
//     requestSearchCriteria: data.skuNumber,
//     dateSelectorValue: contextData.dateSelectorValue,
//   };
// };
// map over array and return each element html and values
var topItemsArray = function (topItemData, redirectQueryParams, showMoreItems, businessToolsHostName) {
    // TODO: Fix any type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sortedArray = topItemData && topItemData.sort(compareAmounts);
    var denominatorAmount = sortedArray ? sortedArray[0] : 0;
    return sortedArray === null || sortedArray === void 0 ? void 0 : sortedArray.map(function (data, i) {
        var itemPercentage = getItemPercentage(data, denominatorAmount);
        var operator = data.totalTransactionAmount && data.totalTransactionAmount < 0 ? '-' : '';
        var redirectUrl = redirectQueryParams.startDate
            ? "".concat(businessToolsHostName, "?requestSearchSelectorValue=SKUNumber&requestSearchCriteria=").concat(data.skuNumber, "&startDate=").concat(redirectQueryParams.startDate, "&endDate=").concat(redirectQueryParams.endDate, "&dateSelectorValue=").concat(redirectQueryParams.dateSelectorValue)
            : "".concat(businessToolsHostName, "?requestSearchSelectorValue=SKUNumber&requestSearchCriteria=").concat(data.skuNumber, "&dateSelectorValue=").concat(redirectQueryParams.dateSelectorValue);
        if ((redirectQueryParams === null || redirectQueryParams === void 0 ? void 0 : redirectQueryParams.poJobName) !== 'all') {
            Object.assign(redirectQueryParams, {
                searchBy: [
                    {
                        SKUNumber: data.skuNumber,
                        POJobName: redirectQueryParams === null || redirectQueryParams === void 0 ? void 0 : redirectQueryParams.poJobName,
                    },
                ],
            });
        }
        if (showMoreItems === 0 && i > 4) {
            return true;
        }
        return (React.createElement("ul", null,
            React.createElement("div", { 
                // TODO: Change to button once CPS can redirect with proper data. No ETA on this
                // type="button"
                // onClick={() => {
                //   getWindow()?.location.assign(redirectUrl);
                // }}
                className: "business-tools__displayBlock", style: { width: '100%' } },
                React.createElement("li", { className: "u__clearfix business-tools__List", key: i },
                    React.createElement("div", { className: "col__2-12 col__1-12--xs business-tools__rmPadding" }, renderItemImage(data)),
                    React.createElement("div", { className: "col__10-12 col__11-12--xs business-tools__addPaddingLeft15 business-tools__rmPaddingRight" },
                        React.createElement("div", { className: "sui-flex", style: { width: '100%' } },
                            React.createElement("h3", null,
                                React.createElement("strong", null, data.skuNumber)),
                            React.createElement("p", { style: { marginLeft: 5 } }, data.shortSkuDescription)),
                        React.createElement("div", { className: "u__flex business-tools__spaceBetween" },
                            React.createElement("p", null, data.shortSkuDescription),
                            React.createElement("p", { className: "business-tools__fontWeight" }, !data.totalQuantity
                                ? "".concat(operator, "$").concat(Math.abs(data.totalTransactionAmount || 0).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                }))
                                : "".concat(data.totalQuantity))),
                        React.createElement("div", { className: "bar-container" },
                            React.createElement("div", { className: "business-tools__Bar business-tools__marginTop--topitems", style: styleBars(itemPercentage) })))))));
    });
};
// function to show more items
var showMoreItemsLogic = function (setShowMoreJobs, setHideMe) {
    setShowMoreJobs(1);
    setHideMe(false);
};
// function to show less items
var showLessItemsLogic = function (setShowMoreJobs, setHideMe) {
    setShowMoreJobs(0);
    setHideMe(true);
};
var renderItemSelectElement = function (selectedValue, setSelectedValue) {
    return (React.createElement(FormController, null,
        React.createElement(FormLabel, null, "Show Items by"),
        React.createElement(Dropdown, { onChange: function (event) {
                var itemSelectvalue = event.target.value;
                setSelectedValue(itemSelectvalue);
            }, value: selectedValue },
            React.createElement(MenuItem, { value: "spend" }, "Spend"),
            React.createElement(MenuItem, { value: "quantity" }, "Quantity"))));
};
var renderSubHeader = function (selectedValue, setSelectedValue) {
    // business-tools__fullWidth u__flex business-tools__subHeader
    return (React.createElement("div", { className: "sui-flex sui-w-full sui-justify-between sui-text-subtle" },
        React.createElement("div", { className: "sui-z-10" }, renderItemSelectElement(selectedValue, setSelectedValue)),
        React.createElement(Typography, { variant: "body-xs", className: "business-tools__specialPadding" }, "Displays Pre-Tax Dollar Spend")));
};
var renderMoreLessButtons = function (topItems, lessMoreState) {
    var hideMe = lessMoreState.hideMe, setShowMoreItems = lessMoreState.setShowMoreItems, setHideMe = lessMoreState.setHideMe;
    if (topItems && topItems.length > 5) {
        return (React.createElement("div", { className: "col__6-12 col__3-12--sm business-tools__rmPaddingLeft" }, hideMe ? (React.createElement("button", { type: "button", className: "bttn-outline bttn--link", id: "showMoreItemsElement", onClick: function () { return showMoreItemsLogic(setShowMoreItems, setHideMe); } },
            React.createElement("span", { className: "bttn__content" }, "Show more items"))) : (React.createElement("button", { type: "button", className: "bttn-outline bttn--link", id: "showLessItemsElement", onClick: function () { return showLessItemsLogic(setShowMoreItems, setHideMe); } },
            React.createElement("span", { className: "bttn__content" }, "Show less")))));
    }
    return undefined;
};
var renderTopSpendByItemsElement = function (topItems, topItemsError, topItemsLoaded, redirectQueryParams, topItemsState, businessToolsHostName) {
    if (topItemsLoaded) {
        if (topItemsError) {
            return BusinessToolsErrorMessage();
        }
        if (topItems && topItems.length > 0) {
            return (React.createElement(React.Fragment, null,
                ' ',
                renderSubHeader(topItemsState.selectedValue, topItemsState.setSelectedValue),
                topItemsArray(topItems, redirectQueryParams, topItemsState.showMoreItems, businessToolsHostName),
                renderMoreLessButtons(topItems, topItemsState)));
        }
        return (React.createElement(Typography, { weight: "bold" }, "No records can be found for the selected date range and/or job name."));
    }
    return React.createElement(TopItemSkeleton, null);
};
export var TopItems = function () {
    var _a = useState('spend'), selectedValue = _a[0], setSelectedValue = _a[1];
    var _b = useState(0), showMoreItems = _b[0], setShowMoreItems = _b[1];
    var _c = useState(true), hideMe = _c[0], setHideMe = _c[1];
    var _d = useState(), topItems = _d[0], setTopItems = _d[1];
    var _e = useState(), topItemsError = _e[0], setTopItemsError = _e[1];
    var _f = useState(false), topItemsLoaded = _f[0], setTopItemsLoaded = _f[1];
    var dateRangeOptions = useCommonContext().dateRangeOptions;
    var _g = useBusinessToolsContext(), dateSelectorValue = _g.dateSelectorValue, requestData = _g.requestData, businessToolsHostName = _g.businessToolsHostName;
    var request = {
        businessToolsRequest: {
            startDate: dateSelectorValue === 'custom'
                ? dateRangeOptions.startDate
                : DateRanges[dateSelectorValue].startDate,
            endDate: dateSelectorValue === 'custom'
                ? dateRangeOptions.endDate
                : DateRanges[dateSelectorValue].endDate,
            jobName: requestData.poJobName,
        },
        customerAccountId: getSvocId() || '',
    };
    useEffect(function () {
        if (selectedValue === 'spend') {
            GetTopSpendByItemSpend(request, setTopItems, setTopItemsError, setTopItemsLoaded);
        }
        else if (selectedValue === 'quantity') {
            GetTopSpendByItemQuantity(request, setTopItems, setTopItemsError, setTopItemsLoaded);
        }
    }, [
        request.businessToolsRequest.startDate,
        request.businessToolsRequest.endDate,
        request.businessToolsRequest.jobName,
        selectedValue,
    ]);
    /**
     * Created to carry common and businessTools context data for
     * sending query data to purchase history.
     */
    var redirectQueryParams = {
        startDate: dateSelectorValue === 'custom'
            ? dateRangeOptions.startDate
            : DateRanges[dateSelectorValue].startDate,
        endDate: dateSelectorValue === 'custom'
            ? dateRangeOptions.endDate
            : DateRanges[dateSelectorValue].endDate,
        dateSelectorValue: dateSelectorValue || 'YTD',
        poJobName: requestData.poJobName || '',
    };
    var topItemsState = {
        selectedValue: selectedValue,
        setSelectedValue: setSelectedValue,
        showMoreItems: showMoreItems,
        setShowMoreItems: setShowMoreItems,
        hideMe: hideMe,
        setHideMe: setHideMe,
    };
    return (React.createElement("div", { className: "top-items" },
        React.createElement(SectionHeader, { title: "Top Items" }),
        renderTopSpendByItemsElement(topItems, topItemsError, topItemsLoaded, redirectQueryParams, topItemsState, businessToolsHostName)));
};
